import DeleteIcon from "@usas/ui-web/components/icons/DeleteIcon";
import EditIcon from "@usas/ui-web/components/icons/EditIcon";

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const SmallGridRow = ({ member, onEditClicked, onEditStatusClicked, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}><span className="hidden-xs">{member.firstName || ''} {member.lastName || ''}</span>&nbsp;
      {onDeleteClicked &&
        <button
          className={global.IconButtonMobileMargin}
          type="button"
          onClick={(e) => onDeleteClicked(e, member)}>
          <DeleteIcon />
        </button>
      }
      {onEditClicked &&
        <button
          className={global.IconButtonMobileMargin}
          type="button"
          onClick={(e) => onEditClicked(e, member)}>
          <EditIcon />
        </button>
      }
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className="row">
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>Name</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3 visible-xs'].join(' ')}>{member.firstName || ''} {member.lastName || ''}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Zone</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{member.zoneOrgUnitCode || ''}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Competition Category</div>
        <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{member.competitionGenderTypeName || ''}</div>
        <div className={[global.SmallTableRowLabels, 'col-xs-6 col-sm-3'].join(' ')}>Status</div>
        {onEditStatusClicked && member.canEditStatus === true
          ? <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}><a onClick={(e) => onEditStatusClicked(e, member)}>{member.personOrgGroupQualificationStatus}</a></div>
          : <div className={[global.SmallTableRowData, 'col-xs-6 col-sm-3'].join(' ')}>{member.personOrgGroupQualificationStatus || ''}</div>
        }
      </div>
    </div>
  </div>
);

const SAAGroupMembersGridSmall = ({ data, isLoading, onEditClicked, onEditStatusClicked, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      )
      : data.length > 0
        ? data.map((member, i) => <SmallGridRow key={i} member={member} onEditClicked={onEditClicked} onEditStatusClicked={onEditStatusClicked} onDeleteClicked={onDeleteClicked} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Group Members</div>
            </div>
          </div>
        )
    }
  </div>
);

export default SAAGroupMembersGridSmall;